import React, { useState } from 'react'
import "./Qualification.css"

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index)
    }
    return (
        <section className="qualification section">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>
            <div className="qualification_container container">
                <div className="qualification_tabs">

                    <div className={toggleState === 1 ? "qualification_button qualification_active button--flex" : "qualification_button  button--flex"}

                        onClick={() => toggleTab(1)}>
                        <i className="uis uis-graduation-cap
                         qualification_icon"></i>
                        Education
                    </div>

                    <div className={toggleState === 2 ? "qualification_button qualification_active button--flex" : "qualification_button  button--flex"}
                        onClick={() => toggleTab(2)}>
                        <i className="uis uis-briefcase-alt '
                        qualification_icon"></i>
                        Experience
                    </div>
                </div>

                <div className="qualification_sections">
                    <div className={toggleState === 1 ? " qualification_content qualification_content-active" : "qualification_content"}>

                        <div className="qualification_data">
                            <div>
                                <h3 className="qualification_title">MBA (Information Technology)</h3>
                                <span className="qualification_subtitle">Savitribai Phule Pune University</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2021 - 2024
                                </div>
                            </div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>
                        </div>

                        <div className="qualification_data">
                            <div></div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>

                            <div>
                                <h3 className="qualification_title">B.Voc (Software Development)</h3>
                                <span className="qualification_subtitle">Rashtrasant Tukadoji Maharaj Nagpur University</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2016 - 2021
                                </div>
                            </div>

                        </div>

                        <div className="qualification_data">
                            <div>
                                <h3 className="qualification_title">Web Development</h3>
                                <span className="qualification_subtitle">Mohabe sir classes Bhandara</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2017 - 2018
                                </div>
                            </div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>
                        </div>

                        <div className="qualification_data">
                            <div></div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>

                            <div>
                                <h3 className="qualification_title">Java Programming</h3>
                                <span className="qualification_subtitle">Mohabe sir classes Bhandara </span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2018 - 2019
                                </div>
                            </div>

                        </div>



                    </div>

                    <div className={toggleState === 2 ? " qualification_content qualification_content-active" : "qualification_content"}>
                        <div className="qualification_data">
                            <div>
                                <h3 className="qualification_title"> Website  Designer</h3>
                                <span className="qualification_subtitle">IMRT Nashik</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2021 - 2024
                                </div>
                            </div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>
                        </div>

                        <div className="qualification_data">
                            <div></div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>

                            <div>
                                <h3 className="qualification_title">Web Application Development</h3>
                                <span className="qualification_subtitle">ProWiggle Data Solutions Pvt Ltd, Bhandara</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2022 - 2023
                                </div>
                            </div>

                        </div>

                        <div className="qualification_data">
                            <div>
                                <h3 className="qualification_title">Full Stack Web Development</h3>
                                <span className="qualification_subtitle">
                                    React - Self</span>
                                <div className="qualification_calender">
                                    <i className="uil uil-calender"></i>2023 - 2024
                                </div>
                            </div>

                            <div>
                                <span className="qualification_rounder"></span>
                                <span className="qualification_line"></span>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section >
    )
}

export default Qualification
